import React from 'react'
import Vehicles from '../../../../components/Project/Resources/Vehicles/Vehicles'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { remove as removeApi, VehiclesApi } from '../../../../api/Projects/Resources'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'

function VehiclesCont (props) {
  const { project } = props
  const { list, fetching, fetch } = useFetchList(() =>
    VehiclesApi.list(project._id, 'vehicles'),
  )
  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const {
    visible,
    modalType,
    object: vehicle,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(VehiclesApi.create, VehiclesApi.update, removeApi, fetch)

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await VehiclesApi.create({ ...newObject, project })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <Vehicles
      {...{
        project,
        list,
        fetching,
        submitting,
        visible,
        fetch,
        vehicle,
        onShow,
        onCancel,
        checkForm,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

VehiclesCont.propTypes = {}
VehiclesCont.defaultProps = {}

export default (VehiclesCont)
